export default class SectionTitleReveal {
    constructor(rootSelector) {
        this.roots = rootSelector
            ? document.querySelectorAll(rootSelector)
            : [document];
        this.titles = [];

        this.roots.forEach((root) => {
            root.querySelectorAll('[data-section-title]:not([data-section-title-ready])').forEach((title) => {
                title.setAttribute('data-section-title-ready', '');
                this.titles.push(title);
            });
        });

        this.ready();
    }

    ready() {
        if (!this.titles.length) return;

        if (!('IntersectionObserver' in window)) {
            this.titles.forEach((title) => this.reveal(title));
            return;
        }

        this.observer = new IntersectionObserver(
            (entries) => this.handleIntersection(entries),
            {
                threshold: 0.35,
                rootMargin: '0px 0px -10% 0px',
            }
        );

        this.titles.forEach((title) => this.observer.observe(title));
    }

    handleIntersection(entries) {
        entries.forEach((entry) => {
            if (!entry.isIntersecting) return;

            this.reveal(entry.target);
            this.observer.unobserve(entry.target);
        });
    }

    reveal(title) {
        title.classList.add('is-revealed');
    }
}
